import { SegmentedControl } from '@/components/ui/segmented-control';
import { setThemePreference, useTheme, type ThemePreference } from '@/lib/theme';

/**
 * Story 25.8 — the Theme choice (EXPERIENCE.md › Theme control), shared by the
 * desktop AvatarMenu and the phone More page's account block. Light · Dark ·
 * System as a SegmentedControl radiogroup named "Theme"; below 400px (or when
 * the segments do not fit) a native `<select>` labelled "Theme".
 *
 * Reads and writes the theme module store only: the choice applies at once
 * without a reload and is saved per browser (never on the account). With
 * storage blocked it still works for the session.
 */
const THEME_OPTIONS: ReadonlyArray<{ value: ThemePreference; label: string }> = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'system', label: 'System' },
];

export default function ThemeControl({ className }: { className?: string }) {
  const { preference } = useTheme();
  return (
    <SegmentedControl
      label="Theme"
      selectLabel="Theme"
      options={THEME_OPTIONS}
      value={preference}
      onChange={(next) => setThemePreference(next as ThemePreference)}
      className={className}
    />
  );
}
